export enum DataVisibility {
  HIDDEN = 'HIDDEN',
  READONLY = 'READONLY',
  EDITABLE = 'EDITABLE',
  MANDATORY = 'MANDATORY'
}
